export const transform = {
  clipPath: {
    scale: true,
  },
  rotate: {
    scale: true,
  },
  scale: {
    scale: true,
  },
  scaleX: {
    scale: true,
  },
  scaleY: {
    scale: true,
  },
  skewX: {
    scale: true,
  },
  skewY: {
    scale: true,
  },
  transform: {
    scale: true,
  },
  transformOrigin: {
    scale: true,
  },
  translateX: {
    scale: true,
  },
  translateY: {
    scale: true,
  },
} as const;
/**
 * NextJS 12.2.5 does not support `satisfies` assertion
 * Once we upgrade NextJS, these should be `as const satisfies ScaleObject`
 */

export type Transform = typeof transform;
